import { handleActions } from 'redux-actions';

import { apiSuccess } from '../apiStatus';
import { GET_ALL_USERS } from '../types/user';

const initialState = {
  status: 'INIT',
  allUsers: [],
  error: null,
};

export const userReducer = handleActions(
  {
    [apiSuccess(GET_ALL_USERS)]: (state, { payload: { data } }) => {
      return {
        ...state,
        allUsers: data,
      };
    },
  },
  initialState
);
